import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { Button, Col, Form, Row, Tooltip, OverlayTrigger } from "react-bootstrap";
import { FaList } from "react-icons/fa";
import * as Yup from "yup";
import { CChart } from "@coreui/react-chartjs";
import useApiClient, { apiRoutes } from "../hooks/apiClient";
import SelectOrgao from "../components/UI/SelectInput/SelectOrgao";
import constants from "./Constants";
import { AuthContext } from "../context/AuthContext";
import funcionalidades from "../context/AuthContext.funcionalidades";
// import { history } from "../history";

const validationSchema = Yup.object().shape({ orgao: Yup.number().default(0) });

const initialValues = {};

validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const Inicio = () => {
  const history = useHistory();
  const [informacaoSinteticaOS, setInformacaoSinteticaOS] = useState({});
  const [informacaoSinteticaOSAberta, setInformacaoSinteticaOSAberta] = useState({});
  const [informacaoSinteticaOSPrazo, setInformacaoSinteticaOSPrazo] = useState({});
  const [informacaoSinteticaOSPF, setInformacaoSinteticaOSPF] = useState({});

  const [listaOSAberta, setListaOSAberta] = useState([]);
  const [listaOSPrazo, setListaOSPrazo] = useState([]);
  const [listaSPF, setListaSPF] = useState([]);
  const [listaExecutorOrdemServico, setListaExecutorOrdemServico] = useState([]);

  const [orgaoId, setOrgaoId] = useState(0);

  const { isAllowed } = useContext(AuthContext);

  const {
    request: requestListarInformacaoSinteticaOS,
    data: dataListaInformacaoSinteticaOS,
    errors: errorListaInformacaoSinteticaOS,
    // isLoading,
  } = useApiClient();

  const {
    request: requestConsultaExecutorOrdemServico,
    data: dataListaExecutorOrdemServico,
    errors: errorExecutorOrdemServico,
    // isLoading,
  } = useApiClient();

  const formik = useFormik({
    initialValues,
    validationSchema,
  });

  const objeto = JSON.parse(localStorage.getItem("user"));

  const { cnpjCpf } = objeto;

  const handleChangeFormik = (descricao) => {
    formik.setFieldValue("orgao", descricao);
    setOrgaoId(descricao);
  };

  const handleRequestConsultarOs = (obj) => {
    history.push({
      pathname: "/app/os/consultarOs",
      state: { codigo: obj.codigo, tipo: obj.tipo, orgao: formik.values.orgao },
    });
  };

  const handleRequestConsultarSPF = (obj) => {
    history.push({
      pathname: "/app/spf/pendencias",
      state: {
        quantidade: obj.quantidade,
        codigo: obj.codigo,
        tipo: obj.tipo,
        orgao: formik.values.orgao,
        todos: constants.spf.todos,
        status: obj.codigo === 0 ? "P" : "H",
        pageNumber: 1,
        pageSize: 50,
        cpf: cnpjCpf,
      },
    });
  };

  useEffect(() => {
    requestListarInformacaoSinteticaOS(apiRoutes.fiscalizacao.ordemservico.listarinformacaosinteticaos, {
      cdUsuario: cnpjCpf,
      sqOrgao: orgaoId,
    });
  }, [requestListarInformacaoSinteticaOS, cnpjCpf, orgaoId]);

  useEffect(() => {
    if (dataListaInformacaoSinteticaOS) {
      setInformacaoSinteticaOS(dataListaInformacaoSinteticaOS.result);
    }
    if (errorListaInformacaoSinteticaOS) {
      toast.error(errorListaInformacaoSinteticaOS.message);
    }
    setInformacaoSinteticaOSAberta(informacaoSinteticaOS.informacaoSinteticaOSAbertaViewModel);
    setInformacaoSinteticaOSPrazo(informacaoSinteticaOS.informacaoSinteticaOSPrazoViewModel);
    setInformacaoSinteticaOSPF(informacaoSinteticaOS.informacaoSinteticaOSPFViewModel);

    setListaOSAberta(informacaoSinteticaOS?.informacaoSinteticaOSAbertaViewModel?.listaOSAbertaViewModels);
    setListaOSPrazo(informacaoSinteticaOS?.informacaoSinteticaOSPrazoViewModel?.listaOSPrazoViewModels);
    setListaSPF(informacaoSinteticaOS?.informacaoSinteticaOSPFViewModel?.listaSPFViewModels);
  }, [
    informacaoSinteticaOS,
    dataListaInformacaoSinteticaOS,
    errorListaInformacaoSinteticaOS,
    listaOSAberta,
    listaOSPrazo,
    listaSPF,
    orgaoId,
  ]);

  useEffect(() => {
    requestConsultaExecutorOrdemServico(apiRoutes.fiscalizacao.parametrizacao.listaOrgao, { cdUsuario: cnpjCpf });
  }, [requestConsultaExecutorOrdemServico, cnpjCpf]);

  useEffect(() => {
    if (dataListaExecutorOrdemServico) {
      setListaExecutorOrdemServico(dataListaExecutorOrdemServico.result);
    }
    if (errorExecutorOrdemServico) {
      toast.error(errorExecutorOrdemServico.message);
    }
  }, [dataListaExecutorOrdemServico, errorExecutorOrdemServico, listaExecutorOrdemServico]);

  const osAbertas = listaOSAberta?.map((obj) => ({ id: crypto.randomUUID(), ...obj }));
  const osPrazos = listaOSPrazo?.map((obj) => ({ id: crypto.randomUUID(), ...obj }));
  const sPFs = listaSPF?.map((obj) => ({ id: crypto.randomUUID(), ...obj }));

  const montarDescricaoLista = (lista) => {
    let i = 0;
    const descricao = [];

    while (i < lista?.length) {
      descricao.push(lista?.map((item) => item.descricao)[i]);

      i += 1;
    }

    return descricao;
  };

  const montarBackground = (lista) => {
    const tamanhoLista = lista?.length;
    const cor = [];

    switch (tamanhoLista) {
      case 1:
        cor.push("#FF6384");
        break;
      case 2:
        cor.push("#FF6384", "#4BC0C0");
        break;
      case 3:
        cor.push("#FF6384", "#4BC0C0", "#FFCE56");
        break;
      case 4:
        cor.push("#FF6384", "#4BC0C0", "#FFCE56", "#E7E9ED");
        break;
      case 5:
        cor.push("#FF6384", "#4BC0C0", "#FFCE56", "#E7E9ED", "#36A2EB");
        break;
      case 6:
        cor.push("#FF6384", "#4BC0C0", "#FFCE56", "#E7E9ED", "#36A2EB", "#DDA0DD");
        break;
      default:
        cor.push("");
    }

    return cor;
  };

  return (
    <>
      {/* <h1 className="h3 mb-4 text-gray-800">Início</h1> */}
      <div className="row">
        <div className="col-lg-12">
          <Form noValidate onSubmit={formik.handleSubmit}>
            {listaExecutorOrdemServico.length > 1 && (
              <Row>
                <Form.Group as={Col} sm={6} md={2}>
                  <Form.Label>Órgão</Form.Label>
                  <SelectOrgao formik={formik} field="orgao" onChange={handleChangeFormik} />
                </Form.Group>
              </Row>
            )}
            <Row>
              <Form.Group as={Col} sm={12} md={4}>
                <div className="card shadow text-white bg-primary mb-3">
                  <div className="card-body">
                    <h5 className="card-title text-center tamanho-fonte">QUANTIDADE DE OS ABERTA - POR TIPO </h5>
                    <p className="card-text text-center tamanho-fonte">
                      {informacaoSinteticaOSAberta?.totalOSAberta ?? 0}
                    </p>
                  </div>
                </div>
                <div className="col-sm-12">
                  <Row>
                    <CChart
                      className="chart-container"
                      type="pie"
                      data={{
                        labels: montarDescricaoLista(listaOSAberta),
                        datasets: [
                          {
                            backgroundColor: montarBackground(listaOSAberta),
                            data: listaOSAberta?.map((value, index, array) => array[index].quantidade) || "",
                          },
                        ],
                      }}
                    />
                  </Row>
                </div>
              </Form.Group>
              <Form.Group as={Col} sm={12} md={4}>
                <div className="card shadow text-white bg-danger mb-3">
                  <div className="card-body">
                    <h5 className="card-title text-center tamanho-fonte">QUANTIDADE DE OS ABERTA - POR PRAZO</h5>
                    <p className="card-text text-center tamanho-fonte">
                      {informacaoSinteticaOSPrazo?.totalOSPrazo ?? 0}
                    </p>
                  </div>
                </div>
                <div className="col-sm-12">
                  <Row>
                    {informacaoSinteticaOSPrazo?.totalOSPrazo > 0 && (
                      <CChart
                        className="chart-container"
                        type="doughnut"
                        data={{
                          labels: montarDescricaoLista(listaOSPrazo),
                          datasets: [
                            {
                              backgroundColor: montarBackground(listaOSPrazo),
                              data: listaOSPrazo?.map((value) => value?.quantidade),
                            },
                          ],
                        }}
                      />
                    )}
                  </Row>
                </div>
              </Form.Group>

              <Form.Group hidden={!(listaExecutorOrdemServico.length > 1)} as={Col} sm={12} md={4}>
                <div className="card shadow text-white bg-warning mb-3">
                  <div className="card-body">
                    <h5 className="card-title text-center tamanho-fonte">QUANTIDADE DE PROCEDIMENTOS FISCAIS </h5>
                    <p hidden className="card-text text-center tamanho-fonte">
                      {informacaoSinteticaOSPF?.totalSPF ?? 0}
                    </p>
                  </div>
                </div>
                <div className="col-sm-12">
                  <Row>
                    <CChart
                      className="chart-container-vertical"
                      type="bar"
                      data={{
                        labels: montarDescricaoLista(listaSPF),
                        datasets: [
                          {
                            label: "Procedimentos",
                            backgroundColor: "#00CED1",
                            data: listaSPF?.map((item) => item.quantidade),
                          },
                        ],
                      }}
                      options={{
                        scales: {
                          x: {
                            grid: { color: "rgba(0, 0, 21, 0.175)" },
                            ticks: { color: "rgba(44, 56, 74, 0.95)" },
                          },
                          y: {
                            grid: { color: "rgba(0, 0, 21, 0.175)" },
                            ticks: {
                              color: "rgba(44, 56, 74, 0.95)",
                              precision: 0, // Define a precisão como 0 para evitar casas decimais
                              callback: (value) => (Number.isInteger(value) ? value : ""),
                            },
                          },
                        },
                      }}
                    />
                  </Row>
                </div>
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} sm={12} md={4}>
                <div className="col-sm-11">
                  <Row>
                    <table className="table">
                      <thead>
                        <tr>{osAbertas?.length > 0 && <th colSpan={2}>LEGENDAS</th>}</tr>
                      </thead>
                      <tbody>
                        {osAbertas?.map(
                          (obj) =>
                            obj.quantidade !== undefined && (
                              <tr key={obj.id}>
                                <td>{obj.descricao}</td>
                                <td className="col-sm-1">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        {obj.quantidade > 0
                                          ? `${obj.quantidade} Ordens  de Serviço `
                                          : `${obj.quantidade} Ordem de Serviço `}
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      className="btn-search-inside btn-md mr-3"
                                      onClick={() => handleRequestConsultarOs(obj)}
                                    >
                                      <FaList />
                                    </Button>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            ),
                        )}
                      </tbody>
                    </table>
                  </Row>
                </div>
              </Form.Group>

              <Form.Group as={Col} sm={12} md={4}>
                <div className="col-sm-11">
                  <Row>
                    <table className="table">
                      <thead>
                        <tr>{osPrazos?.length > 0 && <th colSpan={2}>LEGENDAS</th>}</tr>
                      </thead>
                      <tbody>
                        {osPrazos?.map(
                          (obj) =>
                            obj.quantidade !== undefined && (
                              <tr key={obj.id}>
                                <td>{obj.descricao}</td>
                                <td className="col-sm-1">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        {obj.quantidade > 0
                                          ? `${obj.quantidade} Ordens  de Serviço `
                                          : `${obj.quantidade} Ordem de Serviço `}
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      className="btn-search-inside btn-md mr-3"
                                      onClick={() => handleRequestConsultarOs(obj)}
                                    >
                                      <FaList />
                                    </Button>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            ),
                        )}
                      </tbody>
                    </table>
                  </Row>
                </div>
              </Form.Group>

              <Form.Group hidden={!(listaExecutorOrdemServico.length > 1)} as={Col} sm={12} md={4}>
                <div className="col-sm-11">
                  <Row>
                    <table className="table">
                      <thead>
                        <tr>
                          <th colSpan={2}>LEGENDAS</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sPFs?.map(
                          (obj) =>
                            obj.id !== undefined && (
                              <tr key={obj.id}>
                                <td>{obj.descricao}</td>
                                <td className="col-sm-1">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        {" "}
                                        {isAllowed(funcionalidades.spf.consultar) ? "Consultar" : "Acesso negado"}{" "}
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      variant="bg-transparent"
                                      className="btn-search-inside btn-md mr-3"
                                      onClick={() => handleRequestConsultarSPF(obj)}
                                      disabled={!isAllowed(funcionalidades.spf.consultar)}
                                    >
                                      <FaList />
                                    </Button>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            ),
                        )}
                      </tbody>
                    </table>
                  </Row>
                </div>
              </Form.Group>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Inicio;
